const languages: LanguageKey[] = ['fr', 'en', 'jp'];

export const requiredLanguages: LanguageKey[] = ['fr', 'en'];

export default languages;
